import { render, staticRenderFns } from "./UpdateSimple.vue?vue&type=template&id=83b0f62c"
import script from "./UpdateSimple.vue?vue&type=script&lang=js"
export * from "./UpdateSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports